/**
 * 카카오, 네이버에서 돌아온 곳(/social?ticket=...).
 * 연결된 계정이 있으면 로그인하고(정원이 차면 묻기), 없으면 가입 2단계(사무소 확인)로 간다.
 */
import { useEffect, useRef, useState } from 'react';
import { api, rememberMethod, type Who } from '../api.ts';
import { Confirm, Message, Page } from '../ui.tsx';

export function Social(props: { ticket: string; onSignedIn: (who: Who) => void; onNeedSignup: (provider: '카카오' | '네이버') => void }) {
  const [error, setError] = useState<string | null>(null);
  const [confirm, setConfirm] = useState<string | null>(null);
  const [waiting, setWaiting] = useState(true);

  async function finish(force: boolean) {
    let keep = false;
    try {
      keep = sessionStorage.getItem('ilsoni_keep_login') === '1';
    } catch {
      keep = false;
    }
    const r = await api<{ who?: Who; need_signup?: boolean; provider?: '카카오' | '네이버'; method?: string }>(
      'POST', '/api/auth/social/finish', { ticket: props.ticket, keep_login: keep, force }
    );
    setWaiting(false);
    if (!r.ok) {
      if (r.code === 'confirm_cut') setConfirm(r.message);
      else setError(r.message);
      return;
    }
    if (r.need_signup && r.provider) {
      props.onNeedSignup(r.provider);
      return;
    }
    if (r.who) {
      rememberMethod(r.method ?? '');
      props.onSignedIn(r.who);
    }
  }

  // 화면이 열릴 때 한 번만(간편 가입 표는 한 번만 쓸 수 있다)
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void finish(false);
  }, []);

  return (
    <Page title="일손이">
      {/* 기다리는 동안 빈 화면이면 아무 일도 없는 것처럼 보여 다른 버튼을 누르게 된다(2026-11-02 대표님이 겪음) */}
      {waiting && <Message text="로그인을 확인하고 있어요." kind="info" />}
      <Message text={error} />
      {confirm && <Confirm text={confirm} ok="로그인" onOk={() => void finish(true)} onCancel={() => window.location.assign('/login')} />}
    </Page>
  );
}
